	
	<!-- Loder Start-->
	<div class="loader-wrapper">
	  <div class="loader"></div>
	  <div class="loder-section left-section"></div>
	  <div class="loder-section right-section"></div>
	</div>
	<!-- Loder End -->

	
	
	<!--==================================================-->
	<!----- Start Slider Area ----->
	<!--==================================================-->
	<div class="slider_area d-flex align-items-center slider15" id="home">
		<div class="container home-mob">
			<div class="row">
				<!--Start Single Portfolio -->
				<div class="col-md-6 col-lg-6">
					<div class="single_slider wow fadeInUp" data-wow-delay=".4">
						<div class="slider_content">
							<div class="slider_text">
								<div class="slider_text_inner">
									<h5> Software House Based in Malta </h5>
									<h1> Get the right</h1>
									<h1> IT Solution</h1>
									<h1> for your Business</h1>
									<p>We help you take your online presence to the next level</p>
								</div>
								<div class="slider_button pt-3 d-flex">
									<div class="button">
										<a href="#contact"> Start Now <i class="fa fa-angle-right"></i> </a>
									</div>
								</div>
							</div>
						</div>
						<div class="em-hero-inner-shape rotateme">
							<img src="../../../assets/images/shape/diamond.png" alt="">
						</div>
						<div class="em-hero-inner-shape1 bounce-animate4">
							<img src="../../../assets/images/shape/arrow-long.png" alt="">
						</div>
					</div>
				</div>
				<div class="col-md-6 col-lg-6"> 
					<div class="hero_section_thumb wow fadeInDown" data-wow-delay=".5">
						<div class="hero-main-thumb">
							<img src="../../../assets/images/shape/main-img.png" alt="">
						</div>
						<div class="em-hero-inner-thumb rotateme">
							<img src="../../../assets/images/shape/circle-img2.png" alt="">	
						</div>
						<div class="em-hero-icon-thumb">
							<img src="../../../assets/images/shape/arrow.png" alt="">
						</div>
						<div class="em-hero-inner-thumb1 bounce-animate3">
							<img src="../../../assets/images/shape/envelope.png" alt="">
						</div>
						<div class="em-hero-inner-thumb2 bounce-animate">
							<img src="../../../assets/images/shape/user-plus.png" alt="">
						</div>
						<div class="em-hero-inner-thumb3 bounce-animate4">
							<img src="../../../assets/images/shape/message.png" alt="">
						</div>
						<div class="em-hero-inner-thumb4 bounce-animate5">
							<img src="../../../assets/images/shape/plus.png" alt="">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
		
	<!--==================================================-->
	<!----- End Slider Area ----->
	<!--==================================================-->
	
	<!--==================================================-->
	<!----- Start Feature Area ----->
	<!--==================================================-->
	<div class="feature-area pt-85">
		<div class="container">
			<div class="row">
				<div class="col-lg-12">
					<div class="section_title text_center mb-60 mt-3 wow fadeInDown" data-wow-delay=".4">
						<div class="section_sub_title upper mb-20">
							<h5>Distinctive Skills</h5>
						</div>
						<div class="section_main_title upper pb-15">
							<h1> Engaging Creative  <span> Minds </span></h1>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6 col-lg-6">
					<div class="em-feature-single-box wow fadeInLeft" data-wow-delay=".5">
						<div class="feature-single-box-inner">
							<div class="em-feature-title">
								<h2>Team Brainstorming</h2>
								<p>We use our knowledge and experience <br />to create the best possible solutions.</p>
							</div>
							<div class="em-feature-button">
								<a href="#contact">Learn More</a>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-6 col-lg-6">
					<div class="em-feature-single-box wow fadeInRight" data-wow-delay=".4">
						<div class="feature-single-box-inner1">
							<div class="em-feature-title">
								<h2>Business Collaboration</h2>
								<p>We work hand-in-hand with our clients  <br />so that their business will shine brighter.</p>
							</div>
							<div class="em-feature-button">
								<a href="#contact">Learn More</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!--==================================================-->
	<!----- End Feature Area ----->
	<!--==================================================-->
	
	<!--==================================================-->
	<!----- Start About Area ----->
	<!--==================================================-->
	<div class="about_area pt-120 pb-100" id="about">
		<div class="container">
			<div class="row">
				<div class="col-lg-6 col-md-6">
					<div class="single_about_thumb up wow fadeInDown" data-wow-delay=".3">
						<div class="single_about_thumb_inner">
							<img src="../../../assets/images/about.png" alt="" />
						</div>
						<div class="em-about-shape-thumb">
							<div class="em-about-thmub-inner">
								<!-- <img src="../../../assets/images/about-peple.png" alt=""> -->
							</div>
							<div class="em-about-thmub-inner1">
								<img src="../../../assets/images/circle1.png" alt="">
							</div>
							<div class="em-about-thmub-inner2 rotateme">
								<img src="../../../assets/images/circle.png" alt="">
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-6 col-md-6">
					<div class="section_title text_left mb-30 mt-3 wow fadeInRight" data-wow-delay=".4">
						<div class="section_sub_title mb-3">
							<h5>About Us</h5>
						</div>
						<div class="section_main_title upper">
							<h1>Choose an IT Company that</h1>
							<h1>makes your business <span>Thrive</span></h1>
						</div>
						<div class="section_content_text upper">
							<p>Let us accelerate your next big project with top talent in product engineering, custom software development, QA & software testing, mobile app design, and IT strategy & consulting.</p>
						</div>
					</div>
					<div class="em-about-border-box wow fadeInLeft" data-wow-delay=".5">
						<div class="row em-border">
						<div class="col-md-6 col-lg-6">
							<div class="em-about-icon-box">
								<div class="em-about-icon">
									<img src="../../../assets/images/handshake.png" width="50px" alt="">
								</div>
								<div class="em-about-title">
									<h3>Over 15 years <br/>of Experience</h3>
								</div>
							</div>
						</div>
						<div class="col-md-6 col-lg-6">
							<div class="em-about-icon-box wow fadeInDown" data-wow-delay=".6">
								<div class="em-about-icon">
									<img src="../../../assets/images/headset.png" width="50px" alt="">
								</div>
								<div class="em-about-title">
									<h3>24/7 Technical <br> Support</h3>
								</div>
							</div>
						</div>	
					</div>
					</div>
					<div class="row wow fadeInRight" data-wow-delay=".7">
						<div class="col-md-6 col-lg-5">
							<div class="section_button2 mt-40">
								<div class="abou-button1">
									<a href="#contact"> Contact Us <i class="bi bi-arrow-right" aria-hidden="true"></i></a>
								</div>
							</div>
						</div>
						<div class="col-md-6 col-lg-7">
							<div class="em-about-icon-box mt-40">
								<div class="em-about-icons">
									 <i class="flaticon-call" aria-hidden="true"></i>
								</div>
								<div class="em-about-title2">
									<p>Call for Help</p>
									<h3><a href="tel:+35679062651" style="font-size: 20px;font-weight: 700;margin-top: 2px;">+356 79062651</a></h3>
								</div>
							</div>
						</div>
					</div>	
				</div>
			</div>
			<!-- <div class="em-about-shape">
				<div class="shape-thumb">
					<img src="../../../assets/images/shape-ab.png" alt="">
				</div>
			</div> -->
			
		</div>	
	</div>
	<!--==================================================-->
	<!----- End About Area ----->
	<!--==================================================-->
	
	<!--==================================================-->
	<!----- Start service Area ----->
	<!--==================================================-->
	<div class="service-area pt-100 pb-160" id="services">
		<div class="container">
			<div class="row">
				<div class="col-lg-12">
					<div class="section_title text_center mb-60 mt-3 wow fadeInRight" data-wow-delay=".3">
						<div class="section_sub_title upper mb-20">
							<h5>Featured Services</h5>
						</div>
						<div class="section_main_title upper pb-15">
							<h1>We Provide Outstanding <span> IT Solutions </span></h1>
						</div>
						<div class="section_content_text upper">
							<p>Take a look at our ongoing services</p>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-4 col-lg-4">
					<div class="em-service-single-box wow fadeInLeft" data-wow-delay=".4">
						<div class="em-service-box-inner">
							<div class="em-service-content">
								<div class="em-service-icon">
									<div class="em-icon">
										<img src="../../../assets/images/servic1.png" alt="">
									</div>
									<div class="em-icon-title">
										<h4>Web Development</h4>
									</div>
								</div>
								<div class="em-service-title">
									<h2>Website Applications Development</h2>
								</div>
								<div class="em-service-text">
									<p>We create top-notch web applications with mobile-responsive functionality and unique customizations.</p>
								</div>
								<div class="em-service-button">
									<a href="#contact">Learn More <i class="bi bi-arrow-right-short"></i> </a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-4 col-lg-4">
					<div class="em-service-single-box wow fadeInDown" data-wow-delay=".5">
						<div class="em-service-box-inner">
							<div class="em-service-content">
								<div class="em-service-icon">
									<div class="em-icon">
										<img src="../../../assets/images/servic2.png" alt="">
									</div>
									<div class="em-icon-title">
										<h4>Mobile Development</h4>
									</div>
								</div>
								<div class="em-service-title">
									<h2>IOS & Android Apps Development</h2>
								</div>
								<div class="em-service-text">
									<p>We design and develop unique mobile applications to help you reach your target audience.<br /><br /></p>
								</div>
								<div class="em-service-button">
									<a href="#contact">Learn More <i class="bi bi-arrow-right-short"></i> </a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-4 col-lg-4">
					<div class="em-service-single-box wow fadeInRight" data-wow-delay=".6">
						<div class="em-service-box-inner">
							<div class="em-service-content">
								<div class="em-service-icon">
									<div class="em-icon">
										<img src="../../../assets/images/servic3.png" alt="">
									</div>
									<div class="em-icon-title">
										<h4>Web Hosting</h4>
									</div>
								</div>
								<div class="em-service-title">
									<h2>Cloud Hosting Services</h2>
								</div>
								<div class="em-service-text">
									<p>We offer the resource flexibility and power that you won't find with standard, single-server hosting.<br /><br /><br /></p>
								</div>
								<div class="em-service-button">
									<a href="#contact">Learn More <i class="bi bi-arrow-right-short"></i> </a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-4 col-lg-4">
					<div class="em-service-single-box wow fadeInLeft" data-wow-delay=".7">
						<div class="em-service-box-inner">
							<div class="em-service-content">
								<div class="em-service-icon">
									<div class="em-icon">
										<img src="../../../assets/images/servic4.png" alt="">
									</div>
									<div class="em-icon-title">
										<h4>Social Media</h4>
									</div>
								</div>
								<div class="em-service-title">
									<h2>Marketing Strategy</h2>
								</div>
								<div class="em-service-text">
									<p>Boost traffic and increase engagement towards your platforms with built-in SEO tools. Upkeep your social media platforms through our marketing strategies.</p>
								</div>
								<div class="em-service-button">
									<a href="#contact">Learn More <i class="bi bi-arrow-right-short"></i> </a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-4 col-lg-4">
					<div class="em-service-single-box wow fadeInUp" data-wow-delay=".8">
						<div class="em-service-box-inner">
							<div class="em-service-content">
								<div class="em-service-icon">
									<div class="em-icon">
										<img src="../../../assets/images/servic6.png" alt="">
									</div>
									<div class="em-icon-title">
										<h4>Branding</h4>
									</div>
								</div>
								<div class="em-service-title">
									<h2>Business Branding and Identity</h2>
								</div>
								<div class="em-service-text">
									<p>We will create a unique and outstanding brand for your company.<br /><br /></p>
								</div>
								<div class="em-service-button">
									<a href="#contact">Learn More <i class="bi bi-arrow-right-short"></i> </a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-4 col-lg-4">
					<div class="em-service-single-box wow fadeInRight" data-wow-delay=".4">
						<div class="em-service-box-inner">
							<div class="em-service-content">
								<div class="em-service-icon">
									<div class="em-icon">
										<img src="../../../assets/images/servic5.png" alt="">
									</div>
									<div class="em-icon-title">
										<h4>Consultancy</h4>
									</div>
								</div>
								<div class="em-service-title">
									<h2>IT Consultation and Brainstorming</h2>
								</div>
								<div class="em-service-text">
									<p>Let us help you identify the issue and find the best solution for your tedious IT problems.<br /><br /></p>
								</div>
								<div class="em-service-button">
									<a href="#contact">Learn More <i class="bi bi-arrow-right-short"></i> </a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!--==================================================-->
	<!----- End service Area ----->
	<!--==================================================-->
	
	<!--==================================================-->
	<!----- Start why choose us Area ----->
	<!--==================================================-->
	<div class="why-choose-us pt-80 pb-100">
		<div class="container">
			<div class="row">
				<div class="col-lg-6 col-md-6">
					<div class="section_title text_left mb-30 mt-3 wow fadeInDown" data-wow-delay=".4">
						<div class="section_sub_title mb-3">
							<h5>Why Choose Us</h5>
						</div>
						<div class="section_main_title upper">
							<h1>Branding New Business Solutions, Ideas & The</h1>
							<h1> Advanced <span> Technology</span></h1>
						</div>
						<div class="section_content_text upper1">
							<p>Creating solutions with the latest cutting-edge technology</p>
						</div>
					</div>
	                <div class="prossess-ber-plugin wow fadeInLeft" data-wow-delay=".5">
	                    <span class="prosses-bar">ANGULAR, VUE & REACT</span>
	                    <div id="bar1" class="barfiller">
	                        <div class="tipWrap">
	                            <!-- <span class="tip"></span> -->
	                        </div>
	                        <span class="fill" data-percentage="100"></span>
	                    </div>  
	                    <span class="prosses-bar">HTML5, SCSS & JAVASCRIPT</span>
	                    <div id="bar2" class="barfiller">
	                        <div class="tipWrap">
	                            <!-- <span class="tip"></span> -->
	                        </div>
	                        <span class="fill my-class" data-percentage="100"></span>
	                    </div>
	                    <span class="prosses-bar">MICROSOFT .NET FRAMEWORK</span>
	                    <div id="bar3" class="barfiller">
	                        <div class="tipWrap">
	                            <!-- <span class="tip"></span> -->
	                        </div>
	                        <span class="fill my-class2" data-percentage="100"></span>
	                    </div> 
	                </div>
	            </div>
	            <div class="col-md-6 col-lg-6">
	            	<div class="why-choose-us-thumb pl-5 wow fadeInRight" data-wow-delay=".6">
	            		<img src="../../../assets/images/choose.png" alt="">
	            	</div>
	            </div>
			</div>
		</div>
	</div>
	<!--==================================================-->
	<!----- End why choose us Area ----->
	<!--==================================================-->

	<!--==================================================-->
	<!----- Start call do action Area ----->
	<!--==================================================-->
	<div class="call-do-action pt-60 pb-80">
		<div class="container">
			<div class="row">
				<div class="col-lg-12">
					<div class="call-do-action-content">
						<div class="call-do-action-title text_center wow fadeInDown" data-wow-delay=".4">
							<h1> Hey! Do You Need any Kind </h1>
							<h1> of IT Solution? </h1>
						</div>
						<div class="call-button text_center wow fadeInUp" data-wow-delay=".5">
							<a href="#contact"> Get in Touch with Us Now <i class="bi bi-arrow-right"></i> </a>
						</div>	
						<div class="call-do-thumb-box wow fadeInRight" data-wow-delay=".7s">
							<div class="call-do-thumb bounce-animate3">
								<img src="../../../assets/images/ring.png" alt="">
							</div>
						</div>
						<div class="call-do-thumb-box wow fadeInLeft" data-wow-delay=".6s">
							<div class="call-do-thumb1 bounce-animate2">
								<img src="../../../assets/images/man.png" alt="">
							</div>
						</div>
						<div class="call-do-thumb-box wow fadeInRight" data-wow-delay=".8s">
							<div class="call-do-thumb2 bounce-animate5">
								<img src="../../../assets/images/ball.png" alt="">
							</div>
						</div>
						<div class="call-do-thumb-box">
							<div class="call-do-thumb3 rotateme">
								<img src="../../../assets/images/diamond.png" alt="">
							</div>
						</div>	
						<div class="call-do-thumb-box">
							<div class="call-do-thumb4 bounce-animate4">
								<img src="../../../assets/images/roket.png" alt="">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!--==================================================-->
	<!----- Start call do action Area ----->
	<!--==================================================-->

	<!--==================================================-->
	<!----- Start Portfolio Area ----->
	<!--==================================================-->
	<div class="portfolio_area style-four pt-110 pb-70">
		<div class="container">
			<div class="row">
				<div class="col-lg-12 col-md-12">
					<div class="section_title text_left mb-30 mt-3 wow fadeInDown" data-wow-delay=".3">
						<div class="section_sub_title mb-3">
							<h5> Case Studies </h5>
						</div>
						<div class="section_main_title upper">
							<h1> Our Recent Business <span>Case Studies</span> </h1>
						</div>
					</div>
				</div>
				<!-- Start Section Tile -->
				<!-- <div class="col-lg-6 col-md-6">
					<div class="portfolio_nav wow fadeInUp" data-wow-delay=".4">
						<div class="portfolio_menu">
							<ul class="menu-filtering">
								<li class="current_menu_item" data-filter="*"> All </li>
								<li data-filter=".physics"> Branding </li>
								<li data-filter=".cemes"> Design </li>
								<li data-filter=".math"> Dashboard </li>
								<li data-filter=".english"> Logo </li>
							</ul>
						</div>
					</div>
				</div> -->
			</div>
			<div class="row image_load">
				<div class="col-lg-4 col-md-6 grid-item physics english">
					<div class="single_portfolio wow fadeInLeft" data-wow-delay=".5">
						<div class="single_portfolio_inner">
							<div class="single_portfolio_thumb1">
								<img src="../../../assets/images/portfolio/port1.png" alt="" />
							</div>
						</div>
						<div class="single_portfolio_content1">
							<!-- <div class="single_portfolio_icon">
								<a class="portfolio-icon venobox vbox-item" data-gall="myportfolio" href="../../../assets/images/portfolio/p1.jpg"><i class="bi bi-arrow-right"></i> </a>
							</div> -->
							<div class="single_portfolio_content_inner">
								<div class="portfolio-icon">
									<div class="port-icon-thumb">
										<img src="../../../assets/images/portfolio/code.png" alt="">
									</div>
									<div class="port-icon-title">
										<p>Marketing Strategy</p>
									</div>
								</div>
								<h2>Boosting up our client social media traffic</h2>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-md-6 grid-item cemes">
					<div class="single_portfolio wow fadeInUp" data-wow-delay=".6">
						<div class="single_portfolio_inner">
							<div class="single_portfolio_thumb1">
								<img src="../../../assets/images/portfolio/port2.png" alt="" />
							</div>
						</div>
						<div class="single_portfolio_content1">
							<!-- <div class="single_portfolio_icon">
								<a class="portfolio-icon venobox vbox-item" data-gall="myportfolio" href="../../../assets/images/portfolio/p2.jpg"><i class="bi bi-arrow-right"></i> </a>
							</div> -->
							<div class="single_portfolio_content_inner">
								<div class="portfolio-icon">
									<div class="port-icon-thumb">
										<img src="../../../assets/images/portfolio/code1.png" alt="">
									</div>
									<div class="port-icon-title">
										<p>IT Consultation</p>
									</div>
								</div>
								<h2>Helping our client identifying the main infastructure issues</h2>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-md-6 grid-item cemes">
					<div class="single_portfolio wow fadeInRight" data-wow-delay=".7">
						<div class="single_portfolio_inner">
							<div class="single_portfolio_thumb1">
								<img src="../../../assets/images/portfolio/port3.png" alt="" />
							</div>
						</div>
						<div class="single_portfolio_content1">
							<!-- <div class="single_portfolio_icon">
								<a class="portfolio-icon venobox vbox-item" data-gall="myportfolio" href="../../../assets/images/portfolio/p3.jpg"><i class="bi bi-arrow-right"></i> </a>
							</div> -->
							<div class="single_portfolio_content_inner">
								<div class="portfolio-icon">
									<div class="port-icon-thumb">
										<img src="../../../assets/images/portfolio/code.png" alt="">
									</div>
									<div class="port-icon-title">
										<p>Development</p>
									</div>
								</div>
								<h2>Developed a brand new utility system</h2>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-md-6 grid-item cemes math">
					<div class="single_portfolio wow fadeInLeft" data-wow-delay=".8">
						<div class="single_portfolio_inner">
							<div class="single_portfolio_thumb1">
								<img src="../../../assets/images/portfolio/port4.png" alt="" />
							</div>
						</div>
						<div class="single_portfolio_content1">
							<!-- <div class="single_portfolio_icon">
								<a class="portfolio-icon venobox vbox-item" data-gall="myportfolio" href="../../../assets/images/portfolio/p4.jpg"><i class="bi bi-arrow-right"></i> </a>
							</div> -->
							<div class="single_portfolio_content_inner">
								<div class="portfolio-icon">
									<div class="port-icon-thumb">
										<img src="../../../assets/images/portfolio/code.png" alt="">
									</div>
									<div class="port-icon-title">
										<p>Development</p>
									</div>
								</div>
								<h2>Created a new HR system with complex reporting</h2>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-md-6 grid-item math">
					<div class="single_portfolio admin wow fadeInUp" data-wow-delay=".6">
						<div class="single_portfolio_inner">
							<div class="single_portfolio_thumb1">
								<img src="../../../assets/images/portfolio/port6.png" alt="" />
							</div>
						</div>
						<div class="single_portfolio_content1">
							<!-- <div class="single_portfolio_icon">
								<a class="portfolio-icon venobox vbox-item" data-gall="myportfolio" href="../../../assets/images/portfolio/p6.jpg"><i class="bi bi-arrow-right"></i> </a>
							</div> -->
							<div class="single_portfolio_content_inner">
								<div class="portfolio-icon">
									<div class="port-icon-thumb">
										<img src="../../../assets/images/portfolio/code.png" alt="">
									</div>
									<div class="port-icon-title">
										<p>Development</p>
									</div>
								</div>
								<h2>Scheduled automated dynamic reports</h2>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-md-6 grid-item physics english">
					<div class="single_portfolio admin wow fadeInRight" data-wow-delay=".6">
						<div class="single_portfolio_inner">
							<div class="single_portfolio_thumb1">
								<img src="../../../assets/images/portfolio/port5.png" alt="" />
							</div>
						</div>
						<div class="single_portfolio_content1">
							<!-- <div class="single_portfolio_icon">
								<a class="portfolio-icon venobox vbox-item" data-gall="myportfolio" href="../../../assets/images/portfolio/p5.jpg"><i class="bi bi-arrow-right"></i> </a>
							</div> -->
							<div class="single_portfolio_content_inner">
								<div class="portfolio-icon">
									<div class="port-icon-thumb">
										<img src="../../../assets/images/portfolio/code1.png" alt="">
									</div>
									<div class="port-icon-title">
										<p>Product Design</p>
									</div>
								</div>
								<h2>Fully customized dashboard with a unique design</h2>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!--==================================================-->
	<!----- End Portfolio Area ----->
	<!--==================================================-->

	<!--==================================================-->
	<!----- Start Portfolio Area ----->
	<!--==================================================-->
	<div class="testimonial-area pt-130 pb-100">
		<div class="container">
			<div class="row">
				<div class="col-lg-6 col-md-6">
					<div class="testimonial-single-box1 wow fadeInLeft" data-wow-delay=".5">
						<div class="testimonial-thumb">
							<img src="../../../assets/images/testi/test1.png" alt="">
						</div>
						<div class="testi-counter-box">
							<div class="testi-counter-box-inner">
								<div class="testi-counter-title">
									<h3 class="counter">4.7</h3>
								</div>
								<div class="testi-counter-icon">
									<i class="bi bi-star-fill"></i>
			                        <i class="bi bi-star-fill"></i>
			                        <i class="bi bi-star-fill"></i>
			                        <i class="bi bi-star-fill"></i>
			                        <i class="bi bi-star-half"></i>
								</div>
								<div class="testi-counter-text">
									<span>Ratings</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-6 col-md-6" style="height: 385px;">
					<div class="section_title text_left white mb-30 mt-3 wow fadeInDown" data-wow-delay=".4">
						<div class="section_sub_title mb-3">
							<h5> Client Testimonial </h5>
						</div>
						<div class="section_main_title upper">
							<h1> A word from our </h1>
							<h1> Satisfied Customers </h1>
						</div>
					</div>

					<div class="pic-ctn">
						<div class="pic">
							<div class="em-testimoinal-single-box white">
								<div class="em-testimonial-title">
									<h6>“Fast & efficient service with excellent customer care!”</h6>
									<p>Each time we have an update for our website, Web Monkeyz executes this with proficiency and accuracy, keeping up with today's trends and standards.</p>
								</div>
								<div class="testi-people">
									<div class="people-thumb">
										<img src="../../../assets/images/emblems/angelcrypt.png" width="80px" alt="">
									</div>
									<div class="people-title">
										<h4>Shawn Mizzi</h4>
										<p>Founder, Angelcrypt</p>
									</div>
								</div>
							</div>
						</div>
						<div class="pic">
							<div class="em-testimoinal-single-box white">
								<div class="em-testimonial-title">
									<h6>“A professional approach, great process and friendly personnel!”</h6>
									<p>Web Monkeyz have been supporting our organisation for quite a number of years now. Their quick and courteous response makes all the difference when it comes to customer support. Highly recommended.</p>
								</div>
								<div class="testi-people">
									<div class="people-thumb">
										<img src="../../../assets/images/emblems/caritas.png" width="80px" alt="">
									</div>
									<div class="people-title">
										<h4>Antoine Mifsud</h4>
										<p>ISO, Caritas Malta</p>
									</div>
								</div>
							</div>
						</div>
						<div class="pic">
							<div class="em-testimoinal-single-box white">
								<div class="em-testimonial-title">
									<h6>“Highly Recommended!”</h6>
									<p>Web Monkeyz always found the best solution to my problems in rapid time. Very happy with how they handle things.</p>
								</div>
								<div class="testi-people">
									<div class="people-thumb">
										<img src="../../../assets/images/emblems/spb.png" width="80px" alt="">
									</div>
									<div class="people-title">
										<h4>Reuben Chircop</h4>
										<p>Founder, SPB Homes</p>
									</div>
								</div>
							</div>
						</div>
						<div class="pic">
							<div class="em-testimoinal-single-box white">
								<div class="em-testimonial-title">
									<h6>“Amazing customer service!”</h6>
									<p>The system Web Monkeyz has designed for us is very user friendly and able to quickly get to the information needed. Always very proficient and ready to assist with any difficulties.</p>
								</div>
								<div class="testi-people">
									<div class="people-thumb">
										<img src="../../../assets/images/emblems/hilltop.png" width="80px" alt="">
									</div>
									<div class="people-title">
										<h4>Dorianne D'Anastasi</h4>
										<p>SAE, Hilltop Gardens</p>
									</div>
								</div>
							</div>
						</div>
						<div class="pic"></div>
						<!-- <div class="pic">
							<div class="em-testimoinal-single-box white">
								<div class="em-testimonial-title">
									<h6>“Fast & efficient service with excellent customer care!”</h6>
									<p>Each time we have an update for our website, Web Monkeyz executes this with proficiency and accuracy, keeping up with today's trends and standards.</p>
								</div>
								<div class="testi-people">
									<div class="people-thumb">
										<img src="../../../assets/images/emblems/angelcrypt.png" width="80px" alt="">
									</div>
									<div class="people-title">
										<h4>Shawn Mizzi</h4>
										<p>Founder, Angelcrypt</p>
									</div>
								</div>
							</div>
						</div> -->
					</div>
				</div>
			</div>
		</div>
	</div>
	<!--==================================================-->
	<!----- End Portfolio Area ----->
	<!--==================================================-->

	<!--==================================================-->
	<!----- Start Blog Area ----->
	<!--==================================================-->
	<div class="blog-area blog-new pt-110 pb-40">
		<div class="container">
			<div class="row">
				<div class="col-lg-12">
					<div class="section_title text_left mb-50 mt-3 wow fadeInDown" data-wow-delay=".3">
						<div class="section_sub_title mb-3">
							<h5> Our Clients </h5>
						</div>
						<div class="section_main_title upper">
							<h1> Be part of our satisfied <span>Clients</span>  </h1>
						</div>
                        <div class="row brand-bottom-area pt-50">       
                            <div class="col-md-4 col-lg-4">
                                <div class="brand-thumb wow fadeInDown" data-wow-delay=".5">
                                    <img src="../../../assets/images/logos/axgroup.png" style="margin-top: 20px;" width="150px" alt="">
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-4">
                                <div class="brand-thumb wow fadeInUp" data-wow-delay=".6">
                                    <img src="../../../assets/images/logos/spb.jpg" style="margin-top: 20px;" width="150px" alt="">
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-4">
                                <div class="brand-thumb wow fadeInDown" data-wow-delay=".7">
                                    <img src="../../../assets/images/logos/airmaster.png" style="margin-top: 30px;" width="150px" alt="">
                                </div>
                            </div>
                            
						</div>
						<div class="row brand-bottom-area pt-50">   
							<div class="col-md-4 col-lg-4">
                                <div class="brand-thumb wow fadeInUp" data-wow-delay=".10">
                                    <img src="../../../assets/images/logos/hilltop.png" style="margin-top: 20px;" width="150px" alt="">
                                </div>
                            </div>
							<div class="col-md-4 col-lg-4">
								<div class="brand-thumb wow fadeInDown" data-wow-delay=".10">
                                    <img src="../../../assets/images/logos/caritas.png" style="margin-top: 20px;" width="150px" alt="">
                                </div>
                            </div>
							<div class="col-md-4 col-lg-4">
								<div class="brand-thumb wow fadeInDown" data-wow-delay=".11">
                                    <img src="../../../assets/images/logos/dbg.jpg" style="margin-top: 20px;" width="150px" alt="">
                                </div>
                            </div>
                            
						</div>
						<div class="row brand-bottom-area pt-50">   
							<div class="col-md-4 col-lg-4">
                                <div class="brand-thumb wow fadeInDown" data-wow-delay=".9">
                                    <img src="../../../assets/images/logos/pwsl.png" style="margin-top: 20px;" width="150px" alt="">
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-4">
								<div class="brand-thumb wow fadeInUp" data-wow-delay=".8">
									<img src="../../../assets/images/logos/angelcrypt.png" width="150px" alt="">
                                </div>   
                            </div>
							<div class="col-md-4 col-lg-4">
								<div class="brand-thumb wow fadeInDown" data-wow-delay=".12">
                                    <img src="../../../assets/images/logos/lifeplus.png" width="150px" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
				</div>
			</div>
		</div>
	</div>
	<!--==================================================-->
	<!----- End Blog Area ----->
	<!--==================================================-->

	<!--==================================================-->
	<!----- Start Subscribe Area ----->
	<!--==================================================-->
	<div class="subscribe_area style_three pb-100" id="contact">
		<div class="container">
			<div class="row sbc_bg_box wow fadeInDown" data-wow-delay=".4">
				<div class="col-lg-8 col-md-8">
					<div class="subscribe_bg_box">
						<div class="single_subscribe_contact">
							<div class="subscribe_content_title white pb-15">
								<h2>Contact us</h2>
								<p>Let's get in touch and work together on your next amazing project.<br />
									Call us on <a href="tel:+35679062651" style="color:white !important">+356 79062651</a> or fill in the form below.</p>
							</div>
							<form #contactForm="ngForm" (ngSubmit)="submitContact(contactForm.form);" validate>
								<div class="subscribe_form">
									<input type="text" name="name" id="name" class="form-control contact-text" placeholder="Enter Your Full Name*" ngModel #nameField="ngModel" required maxlength="100">
									<div class="help-block with-errors"></div>
								</div>
								<div class="subscribe_form">
									<input type="email" name="email" id="email" class="form-control contact-text" placeholder="Enter Your Email*" ngModel #nameField="ngModel" required email maxlength="100">
									<div class="help-block with-errors"></div>
								</div>
								<div class="subscribe_form">
									<textarea rows="5" name="message" id="message" class="form-control contact-area" placeholder="Enter Your Query*" ngModel #nameField="ngModel" required maxlength="500"></textarea>
									<div class="help-block with-errors"></div>
								</div>

								<div class="subscribe_form">
									<re-captcha (resolved)="checkCaptcha($event)" style="margin-top:15px; display: block; border-radius:10px;"
									name="recaptchaReactive" ngModel siteKey="6LfKfXkpAAAAABLZhb0iAJb_sA8DNcw2WiN1gItp">
									</re-captcha>
								</div>

								<div style="margin-top: 15px;">
									<span class="contact-error" *ngIf="formSubmit && !contactForm.valid">Please input all required fields. Make sure the email is valid.</span>
									<span class="contact-success" *ngIf="formSuccess">Thank you for your submission.<br />&nbsp;One of our team will get in touch with you soon!</span>
									<div class="lds-ellipsis" *ngIf="loading"><div></div><div></div><div></div><div></div></div>
									<button class="contact-btn mx-auto btn btn-primary" [disabled]="checkEnabled(contactForm.form)" (click)="formSubmit=true">Submit</button> 
								</div>
							</form>
						</div>
					</div>
				</div>
				<div class="col-lg-4"> 
					<div class="subscribe-thumb">
						<img src="../../../assets/images/messege.png" alt="">
					</div>
				</div>
			</div>
		</div>
	</div>
	<!--==================================================-->
	<!----- End Subscribe Area ----->
	<!--==================================================-->

		
